'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileExtention = getFileExtention;
exports.normalizeFileName = normalizeFileName;
exports.sortFiles = sortFiles;
function getFileExtention(fileName) {
  return (/(?:\.([^.]+))?$/.exec(fileName)[1]
  );
}

function normalizeFileName(name) {
  var replaceFn = function replaceFn(match) {
    return match.padStart(14, '0');
  };
  var filenameRegexp = /\.[^/.]+$/;
  return name.replace(filenameRegexp, '').replace(/(\d+)/g, replaceFn).toLowerCase();
}

function sortFiles(files) {
  var sortedFiles = files.sort(function (file1, file2) {
    var name1 = normalizeFileName(file1.name);
    var name2 = normalizeFileName(file2.name);
    return name1 > name2;
  });

  return sortedFiles;
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/files.js
// module id = 869
// module chunks = 1